import { render, staticRenderFns } from "./RestartButton.vue?vue&type=template&id=e35eb2ac"
import script from "./RestartButton.vue?vue&type=script&lang=ts"
export * from "./RestartButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports